import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtxJumboTronComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AtxJumboTronComponent,
    ],
    exports: [
        AtxJumboTronComponent,
    ],
})

export class AtxJumboTronModule {}
